<template>
    <div class="filter-button"
        v-bind:class="{
            'active': openMenu,
            'filter-button--open': openMenu,
            'filter-button--applied': filtersApplied,
            'filter-button--hint': showNewDefaultTxView,
        }">
        <div class="filter-button__main" v-on:click="handleClick">
            <span class="filter-button__icon">
                <icon-filter />
            </span>
            <span class="filter-button__title" v-if="!isTablet && !isMobile">
                {{$t('address.filter.title')}}
            </span>
        </div>
        <div class="filter-button__reset" v-if="filtersApplied" v-on:click.stop="resetFilters">
            <icon-close />
        </div>
    </div>
</template>

<script>
import IconFilter from '@img/icons/lucide/settings-2.svg?vue';
import IconClose from '@img/icons/lucide/x.svg?vue';
import { mapState } from 'vuex';

export default {
    props: ['toggleMenu', 'openMenu'],
    computed: {
        showNewDefaultTxView() {
            return !this.newDefaultTxView && !this.isMobile;
        },
        filtersApplied() {
            return this.$store.getters.historyFiltersApplied(this.$route.params.address);
        },
        ...mapState(['newDefaultTxView']),
    },
    methods: {
        handleClick() {
            this.toggleMenu();
            this.$store.commit('closeNewDefaultTxView');
        },
        resetFilters() {
            this.$store.dispatch('resetHistoryFilters', this.$route.params.address);
        },
    },
    components: {
        IconFilter,
        IconClose,
    },
};
</script>

<style lang="scss">
.filter-button {
    display: inline-flex;
    align-items: center;
    position: relative;
    height: 36px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: -0.01em;
    color: var(--body-muted-text-color);
    user-select: none;
    cursor: pointer;
    z-index: 90001;
    transition: color .15s ease, background-color .15s ease, transform .1s ease;

    &:hover {
        color: var(--body-text-color);
        background: var(--icon-button-hover-background);
    }
    &:active {
        transform: scale(.96);
    }

    &__main {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        height: 100%;
        padding: 0 12px;
    }

    &__icon {
        display: inline-flex;
        position: relative;
        width: 18px;
        height: 18px;
        svg {
            width: 18px;
            height: 18px;
        }
    }

    &__title {
        white-space: nowrap;
    }

    &__reset {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        margin-right: 6px;
        border-radius: 7px;
        opacity: .7;
        cursor: pointer;
        transition: opacity .15s ease, background-color .15s ease;
        svg {
            width: 16px;
            height: 16px;
        }
        &:hover {
            opacity: 1;
            background: var(--blue-bright-background);
        }
    }

    &--hint {
        color: var(--blue-bright);
    }

    // Filters applied: same tinted control as the calendar with a range — icon, title, reset.
    &--applied {
        &, &:hover {
            color: var(--blue-bright);
            background: var(--blue-bright-background);
        }
        // The whole control shouldn't shrink when only the cross is pressed:
        &:active {
            transform: none;
        }
        .filter-button__main {
            padding: 0 6px 0 10px;
            &:active {
                opacity: .8;
            }
        }
    }

    &--open {
        &, &:hover {
            color: var(--blue-bright);
            background: var(--blue-bright-background);
        }
    }
}

@media screen and (max-width: 480px) {
    .filter-button {
        height: 34px;

        &__main {
            min-width: 32px;
            padding: 0;
            justify-content: center;
        }
        &__reset {
            margin-right: 4px;
        }
        &--applied .filter-button__main {
            padding: 0 4px 0 8px;
        }
    }
}
</style>
